import React from 'react'
import { Link } from 'react-router-dom'
function Brown() {
  return (
    <div className='container'>
      <div className='row pt-2'>
        <div className='col-lg-6 pe-0 position-relative brown'>
        <img className='w-100 object-fit-cover' height={300} src={require('../image/slider1.jpg')}/>
        <div className='position-absolute ps-3 mic'>
        <Link to='/entertainment'><button type="button" class="btn btn-danger fw-semibold">ENTERTAINMENT</button>
          <h5 className='text-light pt-3'>Michel Brown Talks About American People.</h5></Link>
        </div>
        </div>
        <div className='col-lg-6 pe-0  position-relative brown'>
        <img className='w-100 object-fit-cover' height={300} src={require('../image/slider2.jpg')}/>
        <div className='position-absolute ps-3 mic'>
          <button type="button" class="btn btn-danger fw-semibold">TRAVEL</button>
          <a href=''><h5 className='text-light pt-3'>Improve Your Health And Stamina By Travelling.</h5></a>
        </div>
        </div>
        <div className='col-lg-4 mt-4 position-relative brown'>
            <img className='w-100 object-fit-cover' height={245} src={require('../image/slider3.jpg')}/>
            <div className='position-absolute ps-3 mic1'>
          <button type="button" class="btn btn-danger fw-semibold">TECHNOLOGY</button>
          <a href=''><h5 className='text-light pt-3'>2021’s Street Trend Revealed: Blurred Lines and Prints.</h5></a>
        </div>
            </div>
            <div className='col-lg-4 mt-4 position-relative brown'>
            <img className='w-100 object-fit-cover' height={245} src={require('../image/slider4.jpg')}/>
            <div className='position-absolute ps-3 mic1'>
          <button type="button" class="btn btn-danger fw-semibold">WORLD</button>
          <Link to='/world'><h5 className='text-light pt-3'>Improve Your Health And Stamina By Travelling..</h5></Link>
        </div>
            </div>
            <div className='col-lg-4 mt-4 position-relative brown'>
            <img className='w-100 object-fit-cover' height={245} src={require('../image/slider5.jpg')}/>
            <div className='position-absolute ps-3 mic1'>
          <button type="button" class="btn btn-danger fw-semibold">HEALTH</button>
          <a href=''><h5 className='text-light pt-3'>Improve Your Health And Stamina By Travelling.</h5></a>
        </div>
            </div>
      </div>
    </div>
  )
}

export default Brown
